import React from "react";
import Card from "../Components/Home/CardRecomendation";
import HBannerCarousel from "../Components/Home/HBannerCarouseol";
import MapListToggle from "../Components/Map/MapListToggle";
import { useScrollToQueryParam } from "@/Hooks/useScrollToQueryParam";

function Home() {
  useScrollToQueryParam();

  return (
    <>
      <HBannerCarousel />
      <div>{/* <LinkIcon/> */}</div>
      <div>
        <Card />
      </div>
      <MapListToggle />
    </>
  );
}

export default Home;
